import React from 'react';
export function TopBar() {
  return <div className="bg-navy-950 text-cream-50 py-2 px-4 text-center text-sm font-medium tracking-wide" data-id="element-250">
      ✝ Para Catequistas y Maestros Católicos
    </div>;
}